import gql from 'graphql-tag';

export const QUERY = gql([
    `
query FindTendanceCatalogueContent($id: String!)
{
  findTendanceCatalogueContent(id: $id) {
    data {

      trendInverted {iv}
      trendTitle {iv}
      trendFontSizeTitle {iv}
      trendSubTitle {iv}
      trendFontSizeSubTitle {iv}
      trendTextColor {iv}
      trendColor {iv}
      trendMainPicture {
        iv {
          url
          fileSize
        }
      }
      trendMainPictureLink {iv}
      trendCtaLink {iv}
      trendCtaText {iv}
      trendCtaStyle {iv}
      products {
        iv {
          id
          hideBrandName
          hideProductName
          hidePrice
        }
      }
    }
  }
}`,
]);
